export const AUTH_API = '/now-api/user/register';
